import { render, staticRenderFns } from "./ApplicationDashboard.vue?vue&type=template&id=3c8d3b08"
import script from "./ApplicationDashboard.vue?vue&type=script&lang=js"
export * from "./ApplicationDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports